import { Component, OnInit } from '@angular/core';
import { Requirement } from '../requirement';
import { QuotationService } from '../quotation.service';
import { VendorService } from '../../vendor/vendor.service';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { environment } from '../../environments/environment';
const baseUrl = environment.baseUrl;
const URL = baseUrl+'/api/upload';

@Component({
  selector: 'app-add-requirement',
  templateUrl: './add-requirement.component.html',
  styleUrls: ['./add-requirement.component.css']
})
export class AddRequirementComponent implements OnInit {

  public uploader: FileUploader;
	authHeader: Array<Headers> = [];
	authToken = '';

  quotation = new Requirement();
  quotationdata : any = {}
  submitted = false;
	vendors: any[];
  quotations: any [];
  requester: any [];
  requirementpath: string;
  
    private newAttribute: any = {};
    requirementForm: FormGroup;
    public isupdate = false;
    public FormName = "Add New Requirement";

  constructor(
    private quotationService: QuotationService, 
    private vendorService : VendorService,
    private location: Location, 
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    public toastr: ToastrManager, 
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
    ) { }

    newPo(): void {
      this.submitted = false;
      this.quotation = new Requirement();
    }

    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.requirementForm.invalid) {
          return this.util.showError("Please enter required fields.");		
      }
    else{
      if(this.isupdate){
        this.update();
      }
      else{
        this.addQuotation();
      }
    }
  }

  addQuotation() {
      //this.submitted = true;
      this.save();
    }
	
   
  private save(): void {	  
   
    this.quotation.requirementdate = new Date();
    this.quotation.createdon = new Date();
    this.quotation.createdby = this.auth.currentUserValue.userid
    this.quotation.status = 0;

	  this.quotationService.addRequirement(this.quotation).subscribe((data :any) => {		
		  this.util.showSuccess("Requirement added successfully.")
		});
		this.router.navigate(['/quotation-list']);
          //for Redirecting to the list view     
  }
  goBack(): void {
    this.location.back();
  }

  update(): void {
    this.submitted = true;
 
    this.quotationService.updateRequirement(this.quotation)
        .subscribe(() => this.util.showSuccess("Requirement update successfully."));
        this.router.navigate(['/quotation-list']);
  }
  
  ngOnInit() {
	// this.quotation.active = 1;
	console.log(this.route.snapshot.paramMap.get('requirementid'));
    if(this.route.snapshot.paramMap.get('requirementid') != null)
    {
      const requirementid = +this.route.snapshot.paramMap.get('requirementid');
       if(requirementid > 0)
       {
         this.getQuotation(requirementid);
       }
       this.isupdate = true;
       this.FormName = "Update Requirement";				 
    }
    this.requirementForm = this.formBuilder.group({			
      requirementfor: [this.quotation.requirementfor,[Validators.required, Validators.required]],
      requirementdetails: [this.quotation.requirementdetails,[Validators.required, Validators.required]],
      // active: [this.quotation.active,[Validators.required, Validators.required]]
    });	


   //requirement upload code starts below 
    this.authToken = 'Bearer ' + this.auth.currentUserValue.token;
		
    this.uploader = new FileUploader({url: URL, authTokenHeader : 'Authorization',authToken: this.authToken ,itemAlias: 'photo'});
    this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };
     //overide the onCompleteItem property of the uploader so we are 
     //able to deal with the server response.
     this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
       
          var response = JSON.parse(response);
          var data = {};
    ;
      if(response.error_code==0){
      
        if(response.data.length > 0)
        {
          this.quotation.requirementpath = "uploads/" + response.data; 
        }
    }
  }
  //requirement upload code ends here
  
  }
  // convenience getter for easy access to form fields
get f() {
  return this.requirementForm.controls
  }
 
 

  getQuotation(requirementid) {
  return this.quotationService.getRequirement(requirementid)
             .subscribe(
              quotation => {              
                this.quotation = quotation              
               }
              );
}

//below function is to restrict special character in input field
omit_special_char(e) {
  var k;
  document.all ? k = e.keyCode : k = e.which;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

}
